import viagsApiDev from "../../chats/api/axiosClientdev";

const UPLOAD_MULTIPLE_FILE_URL = "/api/file/upload-multiple-file";

export interface UploadMultipleFilesResponse {
  StatusCode: number;
  Message: string;
  TotalRecord: number;
  Data: string[]; // Mảng URL của file đã upload
}

/**
 * Upload nhiều file lên server
 * @param files - Mảng file cần upload (File[])
 * @returns Promise với mảng URL của file đã upload
 */
export const uploadMultipleFiles = async (files: File[]): Promise<string[]> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });

  const response = await viagsApiDev.post<UploadMultipleFilesResponse>(UPLOAD_MULTIPLE_FILE_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data.Data;
};
